import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";
import { readQueue, replay } from "../lib/offlineQueue";
import api from "../lib/api";
import { toast } from "sonner";

export default function OfflineBadge() {
    const [online, setOnline] = useState(navigator.onLine);
    const [queued, setQueued] = useState(readQueue().length);

    useEffect(() => {
        const refresh = () => setQueued(readQueue().length);
        const goOnline = async () => {
            setOnline(true);
            const r = await replay(api);
            refresh();
            if (r.processed > 0) toast.success(`Synced ${r.processed} offline actions`);
        };
        const goOffline = () => setOnline(false);
        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);
        window.addEventListener("storage", refresh);
        const id = setInterval(refresh, 5000);
        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
            window.removeEventListener("storage", refresh);
            clearInterval(id);
        };
    }, []);

    if (online && queued === 0) {
        return (
            <span className="og-chip" data-testid="offline-badge" title="Online">
                <Wifi size={12} className="text-emerald-500" /> Online
            </span>
        );
    }
    return (
        <span
            className={`og-chip ${online ? "bg-amber-100 text-amber-800" : "bg-rose-100 text-rose-700"}`}
            data-testid="offline-badge"
            title={online ? `${queued} queued actions waiting to sync` : "Offline — queueing actions"}
        >
            <WifiOff size={12} /> {online ? `${queued} queued` : "Offline"}
        </span>
    );
}
